;(function($, undefined){

    'use strict';

    var rnn = window.rnn;

    function Validator(data, extra){
        
        if(extra){
            this.extra = extra;
        }

        if(data.constructor === Array){
            this.validateNumber(data);
        }else{
            this.validateCharacters(data);
        }
    }

    function isNumber(num) { 
        return /^[\d.]+(?:e-?\d+)?$/.test(num);
    }

    function isAlphaNumerical(string){
        return /^[a-z0-9]+$/i.test(string);
    }

    function doesExist(string){
        if(string.length === 0){
            return false;
        }else{
            return true;
        }
    }

    Validator.prototype = {

        canReturn: true,
        errorText: '',
        extra: null,

        validateNumber: function(array){
            // number validation checks whether or not any pieces of data
            // is not a number.
            for (var i = 0; i < array.length; i++) {
                var curr = isNumber(array[i]);
                if(curr === false){
                    this.canReturn = false;
                    this.generateErrorText('num');
                }else{                    
                    if(this.extra === 'numericOrder' && i > 0){
                        // make sure that the current value is higher than the one before it.
                        if(parseInt(array[i]) < parseInt(array[i-1])){
                            this.canReturn = false;
                            this.generateErrorText('num', 'order');
                        }
                    }
                    if(this.extra === 'maxValue' && i != array.length - 1){
                        // The last value is the maximum value for the whole array
                        if(parseInt(array[i]) > parseInt(array[array.length - 1])){
                            this.canReturn = false;
                            this.generateErrorText('num', 'maxValue', array[array.length - 1]);
                        }
                    }
                }
            }
        },

        validateCharacters: function(string){
            
            var valid;

            if(this.extra === 'basic'){
                valid = doesExist(string);
            }else{
                valid = isAlphaNumerical(string);
            }
            
            if(valid === false){
                this.canReturn = false;
                this.generateErrorText('string');
            }
        },

        generateErrorText: function(type, order, args){
            if(type === 'num'){
                if (order == 'maxValue') {
                    this.errorText = 'Maximum value is ' + args + '.';
                }
                else if (order) {
                    this.errorText = 'Min cannot be greater than max.';
                } else {
                    this.errorText = 'Use numerical characters only (0-9).';
                }
                
            }else if(type === 'string'){
                if(this.extra === 'basic'){
                    this.errorText = 'Please enter a value.';
                }else{
                    this.errorText = 'Use alphanumerical characters only (A-Z, 0-9).';
                }
            }
        }
    };

    function validateMe(data, extra){
        var validator = new Validator(data, extra);
        return validator;
    }

    function initValidator() {
        // init
    }

    rnn.modules.register('validator', {
        init: initValidator,
        validate: validateMe
    });

})(jQuery);
